import React from "react";
import { StyleSheet, Text, View } from "react-native";

import BaseProfileCard from "@/screens/Explore/Components/ProfileCard/BaseProfileCard";
import CommonInterests from "@/screens/Explore/Components/ProfileCard/Components/CommonInterests";
import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";
import { UserRecommendedItem } from "@/schemas/user/explore";
import { trimText } from "@/formatting/text";
import { EXPLORE_CONSTANTS, ProfileCardState } from "@/utils/explore";

type Props = {
  profile: UserRecommendedItem;
  itemWidth: number;
  itemHeight: number;
  cardState?: ProfileCardState;
  onNonNormalStateCardClick?: () => void;
};

function LargeProfileCard({
  profile,
  itemWidth,
  itemHeight,
  cardState = "normal",
  onNonNormalStateCardClick = (): void => {},
}: Props): React.JSX.Element {
  return (
    <BaseProfileCard
      profile={profile}
      itemWidth={itemWidth}
      itemHeight={itemHeight}
      isLargeCard={true}
      cardState={cardState}
      onNonNormalStateCardClick={onNonNormalStateCardClick}
    >
      <View style={styles.bottomContainerOverlay}>
        {/* username */}
        <View style={styles.usernameContainer}>
          <Text
            style={styles.usernameText}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            @{profile.username}
          </Text>
        </View>

        {/* about me */}
        {profile.profileAttributes.aboutMe && (
          <Text style={styles.aboutMeText}>
            {trimText(
              profile.profileAttributes.aboutMe,
              EXPLORE_CONSTANTS.MAX_ABOUT_ME_LENGTH,
            )}
          </Text>
        )}

        {/* common interests (styles handled by the component) */}
        {profile.commonInterests && (
          <CommonInterests
            interests={profile.commonInterests}
            isLargeCard={true}
          />
        )}
      </View>
    </BaseProfileCard>
  );
}

const currentTheme = themes.morning;

const styles = StyleSheet.create({
  bottomContainerOverlay: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.50)",
    paddingVertical: Spacings.s2,
    paddingHorizontal: Spacings.s4,
  },
  usernameContainer: {
    flexDirection: "row",
    alignItems: "flex-end",
  },
  usernameText: {
    color: "#eee",
    fontSize: currentTheme.typography.h2.size.mobile + 5,
    fontWeight: "bold",
  },
  aboutMeText: {
    color: "#eee",
    marginVertical: Spacings.s1,
  },
});

export default LargeProfileCard;
